import { TEACHER_SCHEDULED_TEST_PAGE_ROUTES } from "constants/routes";
import { useCurrentPathMatch } from "hooks/useCurrentPathMatch";
import { useProduct } from "hooks/useProduct";
import { observer } from "mobx-react";
import type React from "react";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { TeacherPageLayout } from "../components/TeacherPageLayout/TeacherPageLayout";

import { LoadingSpinner } from "components/LoadingSpinner";
import { useSelectedProductId } from "hooks/useSelectedProductId";

// Pages where the side menu should not appear
const routesWithoutSideMenu: string[] = [
  TEACHER_SCHEDULED_TEST_PAGE_ROUTES.SCHEDULED_TEST_RESULTS_FOR_STUDENT,
];

export const TeacherDashboard: React.FC = observer(() => {
  const { productsList, productDetails, fetchProducts, fetchProductDetails } = useProduct();
  const selectedProductId = useSelectedProductId();
  const { currentRouteMatchesAny } = useCurrentPathMatch();

  useEffect(() => {
    if (!productsList) {
      fetchProducts();
    }
  }, [productsList, fetchProducts]);

  // We need to make sure the product details are always loaded, as part of the menu items
  // are dependant on this data (ex.: teacher instructions or basic progress)
  useEffect(() => {
    if (selectedProductId && productDetails?.id !== +selectedProductId) {
      fetchProductDetails(+selectedProductId);
    }
  }, [productDetails, selectedProductId]);

  if (!productsList) {
    return <LoadingSpinner isFullScreen />;
  }

  const shouldShowSideNav = !currentRouteMatchesAny(routesWithoutSideMenu);

  return (
    <TeacherPageLayout withMenu={shouldShowSideNav}>
      <Outlet />
    </TeacherPageLayout>
  );
});
